import { z } from "zod";

export const CreditTypeSchema = z.enum(["IMAGE_TO_TEXT", "TEXT_TO_IMAGE"]);

export type CreditType = z.infer<typeof CreditTypeSchema>;

export interface CreditLimit {
	type: CreditType;
	amount: number;
	period: "daily" | "monthly";
}

export interface PlanCredits {
	name: string;
	price: number;
	currency: string;
	credits: CreditLimit[];
}

export const plans: Record<string, PlanCredits> = {
	free: {
		name: "Free",
		price: 0,
		currency: "USD",
		credits: [
			{
				type: "IMAGE_TO_TEXT",
				amount: 5,
				period: "daily",
			},
			{
				type: "TEXT_TO_IMAGE",
				amount: 5,
				period: "daily",
			},
		],
	},
	starter: {
		name: "Starter",
		price: 4.99,
		currency: "USD",
		credits: [
			{
				type: "IMAGE_TO_TEXT",
				amount: 1000,
				period: "monthly",
			},
			{
				type: "TEXT_TO_IMAGE",
				amount: 1000,
				period: "monthly",
			},
		],
	},
	pro: {
		name: "Pro",
		price: 9.99,
		currency: "USD",
		credits: [
			{
				type: "IMAGE_TO_TEXT",
				amount: 3000,
				period: "monthly",
			},
			{
				type: "TEXT_TO_IMAGE",
				amount: 3000,
				period: "monthly",
			},
		],
	},
};

export const getPlanCredits = (planId: string): PlanCredits => {
	const plan = plans[planId];
	if (!plan) {
		throw new Error(`Plan ${planId} not found`);
	}
	return plan;
};

export const getCreditLimit = (
	planId: string,
	creditType: CreditType,
): CreditLimit => {
	const plan = getPlanCredits(planId);
	const credit = plan.credits.find((c) => c.type === creditType);
	if (!credit) {
		throw new Error(
			`Credit type ${creditType} not found for plan ${planId}`,
		);
	}
	return credit;
};
